import { createFileRoute } from "@tanstack/react-router";

import { PgmqAdmin } from "@/features/pgmq-admin";

export const Route = createFileRoute("/_authenticated/pgmq-admin/")({
  component: PgmqAdmin,
});
